/**
 * Kernow Header, Mobile Search Overlay, Cart Auto-Updater & Navigation Drawer
 */
document.addEventListener('DOMContentLoaded', () => {
    const routesRoot = window.Shopify?.routes?.root || '/';

    /* ==========================================================================
       1. Mobile Search Overlay Toggle & Auto-Open
       ========================================================================== */
    const searchTrigger = document.getElementById('KernowMobileSearchTrigger');
    const searchBar = document.getElementById('KernowMobileSearchBar');

    if (searchTrigger && searchBar) {
        // Auto-open mobile search overlay if an active search query exists in the URL
        const urlParams = new URLSearchParams(window.location.search);
        const searchParam = urlParams.get('q');

        if (searchParam && searchParam.trim() !== '') {
            searchBar.removeAttribute('hidden');
            searchTrigger.setAttribute('aria-expanded', 'true');
        }

        // Toggle overlay visibility
        searchTrigger.addEventListener('click', (e) => {
            e.preventDefault();
            const isHidden = searchBar.hasAttribute('hidden');

            if (isHidden) {
                searchBar.removeAttribute('hidden');
                searchTrigger.setAttribute('aria-expanded', 'true');

                const input = searchBar.querySelector('input[type="search"], input[name="q"]');
                if (input) setTimeout(() => input.focus(), 100);
            } else {
                searchBar.setAttribute('hidden', '');
                searchTrigger.setAttribute('aria-expanded', 'false');
            }
        });
    }


    /* ==========================================================================
       2. Native Predictive Search Controller (Multi-Instance Scoped)
       ========================================================================== */
    const searchContainers = document.querySelectorAll('[data-kernow-search]');

    searchContainers.forEach((container) => {
        const input = container.querySelector('.kernow-search__input');
        const resultsContainer = container.querySelector('.kernow-search__results-container');
        const resetButton = container.querySelector('.kernow-search__reset');

        if (!input || !resultsContainer) return;

        let debounceTimer;

        input.addEventListener('input', (e) => {
            clearTimeout(debounceTimer);
            const query = e.target.value.trim();

            if (query.length < 2) {
                resultsContainer.innerHTML = '';
                resultsContainer.hidden = true;
                return;
            }

            debounceTimer = setTimeout(() => {
                fetch(`${routesRoot}search/suggest?q=${encodeURIComponent(query)}&resources[type]=product,collection,page,article&resources[options][unavailable_products]=hide&section_id=predictive-search`)
                    .then((response) => response.text())
                    .then((htmlText) => {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(htmlText, 'text/html');

                        const resultsMarkup = doc.querySelector('#predictive-search-results')
                            || doc.querySelector('#shopify-section-predictive-search')
                            || doc.body;

                        const content = resultsMarkup ? resultsMarkup.innerHTML.trim() : '';

                        if (content !== '') {
                            resultsContainer.innerHTML = content;
                            resultsContainer.hidden = false;
                        } else {
                            resultsContainer.innerHTML = '';
                            resultsContainer.hidden = true;
                        }
                    })
                    .catch((err) => console.error('Search fetch error:', err));
            }, 250);
        });

        if (resetButton) {
            resetButton.addEventListener('click', (e) => {
                e.preventDefault();
                input.value = '';
                resultsContainer.hidden = true;
                resultsContainer.innerHTML = '';
                input.focus();
            });
        }
    });

    // Hide search dropdown results when clicking outside active form
    document.addEventListener('click', (e) => {
        searchContainers.forEach((container) => {
            const resultsContainer = container.querySelector('.kernow-search__results-container');
            if (resultsContainer && !container.contains(e.target)) {
                resultsContainer.hidden = true;
            }
        });
    });


    /* ==========================================================================
       3. Kernow Header Cart Count Auto-Updater
       ========================================================================== */
    const updateHeaderCartCount = () => {
        fetch(`${routesRoot}cart.js`)
            .then((response) => response.json())
            .then((cart) => {
                const countElements = document.querySelectorAll('.item_count');

                countElements.forEach((el) => {
                    el.textContent = cart.item_count;

                    if (cart.item_count > 0) {
                        el.classList.remove('hidden');
                        el.removeAttribute('hidden');
                    } else {
                        el.classList.add('hidden');
                    }
                });
            })
            .catch((err) => console.error('Error fetching cart:', err));
    };

    // Intercept standard theme and web component events
    document.addEventListener('cart:updated', updateHeaderCartCount);
    document.addEventListener('cart:refresh', updateHeaderCartCount);
    document.addEventListener('cart-drawer:updated', updateHeaderCartCount);

    // Catch form submits targeting /cart/add
    document.addEventListener('submit', (e) => {
        if (e.target.action && e.target.action.includes('/cart/add')) {
            setTimeout(updateHeaderCartCount, 400);
        }
    });


    /* ==========================================================================
       4. Off-Screen Menu Drawer Controller
       ========================================================================== */
    const openBtn = document.getElementById('KernowDrawerOpen');
    const closeBtn = document.getElementById('KernowDrawerClose');
    const overlay = document.getElementById('KernowDrawerCloseOverlay');
    const drawer = document.getElementById('KernowNavDrawer');

    const openDrawer = () => {
        if (!drawer) return;
        drawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        if (closeBtn) closeBtn.focus();
    };

    const closeDrawer = () => {
        if (!drawer) return;
        drawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        if (openBtn) openBtn.focus();
    };

    if (openBtn) openBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && drawer && drawer.getAttribute('aria-hidden') === 'false') {
            closeDrawer();
        }
    });
});


/* ==========================================================================
   5. Featured Collection Shuffler
   ========================================================================== */
(function () {
    function shuffleCollectionContainer(container) {
        if (container.dataset.shuffled === 'true') return;

        // Target product items only, leaving collection teaser cards untouched
        const productItems = Array.from(container.children).filter((child) => {
            return child.classList.contains('grid-item') && !child.querySelector('.card-overlay');
        });

        if (productItems.length <= 1) return;

        // Calculate current epoch hour
        const hourSeed = Math.floor(Date.now() / (1000 * 60 * 60));

        // Mulberry32 PRNG
        let a = hourSeed;
        function seededRandom() {
            let t = (a += 0x6d2b79f5);
            t = Math.imul(t ^ (t >>> 15), t | 1);
            t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
            return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
        }

        // Fisher–Yates shuffle
        for (let i = productItems.length - 1; i > 0; i--) {
            const j = Math.floor(seededRandom() * (i + 1));
            const temp = productItems[i];
            productItems[i] = productItems[j];
            productItems[j] = temp;
        }

        // Check for an end-anchored collection promo card
        const lastChild = container.lastElementChild;
        const endCard = (lastChild && lastChild.querySelector('.card-overlay')) ? lastChild : null;

        // Re-append nodes in the shuffled sequence
        productItems.forEach((item) => {
            if (endCard) {
                container.insertBefore(item, endCard);
            } else {
                container.appendChild(item);
            }
        });

        container.dataset.shuffled = 'true';
    }

    function runShuffle() {
        document.querySelectorAll('[data-hourly-shuffle="true"]').forEach(shuffleCollectionContainer);
    }

    // Execute immediately if elements already parsed, otherwise wait for interactive state
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', runShuffle);
    } else {
        runShuffle();
    }

    // Support Theme Customiser live section refreshes
    document.addEventListener('shopify:section:load', (e) => {
        const el = e.target.querySelector('[data-hourly-shuffle="true"]');
        if (el) {
            delete el.dataset.shuffled;
            shuffleCollectionContainer(el);
        }
    });
})();